import React from "react";

class AccountFooter extends React.Component {
    render() {
        return (
            <>

            </>
        );
    }
}

export default AccountFooter;